import { useTranslation } from "react-i18next";
import { Center, Text } from "@mantine/core";

import { getQuestionnaireOverage } from "../../CreateCampaignInquiryForm/utils";
import { useQuestionnaireFormContext } from "../formContext";

export interface QuestionsOverLimitProps {
    questionsLimit: number;
}

/**
 * TTV2-1659: tells the client, live, how many questions they have, what their limit is and how
 * many to delete. Computed from the editor's own form values, so it follows every edit; renders
 * nothing while the questionnaire is within its limit.
 */
export const QuestionsOverLimit = ({ questionsLimit }: QuestionsOverLimitProps) => {
    const { t } = useTranslation(["common"]);

    const questionnaireForm = useQuestionnaireFormContext();

    const overage = getQuestionnaireOverage(questionnaireForm.values?.questions, questionsLimit);

    if (!overage) {
        return null;
    }

    return (
        <Center mt="xs">
            <Text color="red">{t("questionnaire_questions_over_limit", overage)}</Text>
        </Center>
    );
};
